import { EntityChildCreateModal } from '@/pages/admin/shared/entity-management/EntityChildCreateModal';

type DepartmentOption = { id: string; name: string };

type CreateSectorModalProps = {
	isOpen: boolean;
	onClose: () => void;
	departments: DepartmentOption[];
	defaultDepartmentId?: string;
	onCreate: (departmentId: string, sectorName: string) => void;
};

export const CreateSectorModal = ({
	isOpen,
	onClose,
	departments,
	defaultDepartmentId = '',
	onCreate,
}: CreateSectorModalProps) => {
	return (
		<EntityChildCreateModal
			isOpen={isOpen}
			onClose={onClose}
			options={departments}
			defaultOptionId={defaultDepartmentId}
			title="Criar Setor"
			description="Vincule um novo setor a um departamento existente."
			selectLabel="DEPARTAMENTO"
			selectPlaceholder="Selecione um departamento"
			childLabel="NOME DO SETOR"
			childPlaceholder="Ex: Recrutamento"
			submitText="Criar setor"
			selectId="modal-sector-dept"
			inputId="modal-sector-name"
			onCreate={onCreate}
		/>
	);
};
